module.exports = __webpack_public_path__ + "static/media/icon-send.00707834.svg";